import React from 'react';

const EmptyChatState = () => (
	<div className="flex flex-1 items-center justify-center text-text-secondary">
		{'Select a chat to start messaging'}
	</div>
);

export default EmptyChatState;
